import { computed } from 'vue'
import { useRoute, useRouter, type LocationQuery } from 'vue-router'

// import translator from '@composables/translator'

export const queryController = () => {
  const route = useRoute()
  const router = useRouter()

  const routeQuery = computed<LocationQuery>(() => route?.query ?? {})

  const cleanQueryObjFromEmpty = <T extends Record<string, any>>(obj: T): Partial<T> => {
    const result: Partial<T> = {}
    for (const [key, value] of Object.entries(obj)) {
      if (value !== '' && value !== null && value !== undefined) {
        result[key as keyof T] = value
      }
    }
    return result
  }

  const addQuery = <T extends string | number | symbol>(query: { [key in T]?: string | undefined }) => {
    router.replace({ name: route.name as string, query: { ...query } })
  }

  const getQueryString = (query: LocationQuery, key: string, defaultValue = ''): string => {
    const value = query[key]
    return typeof value === 'string' ? value : defaultValue
  }

  const getQueryByKey = <T>(queryKey: T): string[] | undefined => {
    const queryVals = routeQuery.value[`${queryKey}`]

    if (!queryVals) {
      return undefined
    }

     return Array.isArray(queryVals)
       ? queryVals as string[]
       : queryVals.split(',')
   }
  //
  // const createChipsByFiltersQuery = <T>(filterList: T[]) =>
  //   filterList.reduce((acc: [T, string][], cur: T) => {
  //     const queryFilterVals: string[] | undefined = getQueryByKey<T>(cur)
  //
  //     if (queryFilterVals) {
  //       const chipTextLabel = translator(`chips.filters.label.${cur}`)
  //       acc.push([cur, `${chipTextLabel}: ${queryFilterVals.join(', ')}`])
  //     }
  //
  //     return acc
  //   }, [] as [T, string][])
  //
  // const clearQuery = <T extends string | number | symbol>(queryList: T[]) => {
  //   const preparedQuery = queryList.reduce((acc: { [key in T]: string | undefined }, cur: T) => {
  //     acc[cur] = undefined
  //     return acc
  //   }, {} as { [key in T]: string | undefined })
  //
  //   addQuery<T>(preparedQuery)
  // }

  return {
    addQuery,
    getQueryByKey,
    cleanQueryObjFromEmpty,
    getQueryString
    // createChipsByFiltersQuery,
    // clearQuery
  }
}
